export const applyTheme = (theme: string) => {
  // Define allowed theme types
  type ThemeName = 'bullebleue' | 'jimetjoe' | 'santevet';

  // Define the proper type for CSS/SCSS module imports
  type CssModule = { [className: string]: string };

  const themeModules: Record<ThemeName, () => Promise<{ default: CssModule }>> =
    {
      bullebleue: () => import('./themes/bullebleue-export.scss'),
      jimetjoe: () => import('./themes/jim-joe-export.scss'),
      santevet: () => import('./themes/santevet-export.scss'),
    };

  // Check if the theme is valid and cast it properly
  const validThemes: ThemeName[] = ['bullebleue', 'jimetjoe', 'santevet'];

  if (validThemes.includes(theme as ThemeName)) {
    themeModules[theme as ThemeName]();
  }
};
